import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';
import { Animate } from '../../animation/animation';
import { StylesContext } from '../../../contexts/styles-context/styles.context';

import styles from './progress.module.scss';

interface ProgressProps {
	active: boolean
	quizProgress: number
}

export default function Progress({ active, quizProgress}:ProgressProps) {
	const [ passed, setPassed ] = useState(0);
	const { styles: { progressTrack = {} } } = useContext(StylesContext);

	
	useEffect(() => {
		var timer:number;
		function doCount(value:number) {
			timer = window.setTimeout(() => {
				if (passed >= value) return;
				setPassed((value > passed) ? (passed + 1) : (passed - 1));
			}, 50);
		};

		doCount(quizProgress);
		
    return () => window.clearTimeout(timer);
		
	}, [quizProgress, passed])
	
	const style = { ...progressTrack, width: `${quizProgress || 0}%` };

	return (
		<Animate duration={400} when={active} animation={'go_down_with_fade'}>
			<div className={classNames(styles.progress)}>
				<div className={styles.track} style={style}></div>
			</div>
		</Animate>
	);
}